import { StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";
import { $confirm } from "../../../../@custom_types/confirm";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { Record } from "../../../records/server/crud";

export class ContactBookDetailController implements IOnInit {
  static $inject = ["$state", "$confirm", ServerUtilityName];
  contactBookDetail!: Record;
  constructor(
    private readonly $state: StateService,
    private readonly $confirm: $confirm,
    private readonly serverUtility: ServerUtility
  ) {}

  $onInit(): void {}

  delete() {
    this.$confirm({
      text: "Are you sure you want to delete this contact?",
    })
      .then(() =>
        this.serverUtility.delete({
          url: "/api/addressBook/AddressBook",
          id: this.contactBookDetail.Id,
        })
      )
      .then(() => this.$state.go("^.grid"));
  }
}
